import { render, staticRenderFns } from "./FormulationStockReport.vue?vue&type=template&id=040f30ff&scoped=true&"
import script from "./FormulationStockReport.vue?vue&type=script&lang=js&"
export * from "./FormulationStockReport.vue?vue&type=script&lang=js&"
import style0 from "./FormulationStockReport.vue?vue&type=style&index=0&id=040f30ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f30ff",
  null
  
)

export default component.exports